import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { Constant } from 'src/app/constant/constant';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FileUploadModule } from 'ng2-file-upload';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DirectiveModule } from 'src/app/shared/directive/directive.module';

@Component({
  standalone: true,
  selector: 'calsoft-file-upload-popup',
  templateUrl: './file-upload-popup.component.html',
  styleUrls: ['./file-upload-popup.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FileUploadModule,
    CustomFlexLayoutModule,
    SharedModule,
    DirectiveModule
  ]
})
export class FileUploadPopupComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';


  locations: any = "calsoftgroup.com";

  @Output() fileUploadResult = new EventEmitter();

  imageChangedEvent: any = '';

  fileName: any;
  row: any;
  uploadProgress = 0;
  uploadInProgress = false;
  text: string;
  item: FileLikeObject;
  data: any;
  noteId: any;
  note: any;
  Notetype: any;
  NoteTitle: any;
  id: any;
  uploadedMediaFileName: string;
  mimeType: string;
  uploadedMediaType: string;
  uploadedMediaUrl: string;

  firstFormGroup: UntypedFormGroup;

  selectedFile: FileLikeObject | null = null;
  setAsDisplayPicture = false;
  buttonEnable: boolean = false;
  data1: any;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  @ViewChild("myInput", { static: false }) myInputVariable!: ElementRef<HTMLInputElement>;


  type: any = 1;


  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<FileUploadPopupComponent>,
    private crmNoteService: CrmNoteService,
    private templatesService: TemplatesService,
    private fileUploadService: FileUploadService,
    private snackBar: MatSnackBar, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.data = data;
    this.noteId = data['noteId'];
    this.note = data['note']
    this.Notetype = data['designType']
    this.NoteTitle = data['title']
    this.type = data['type']
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {

    this.text = "Add";
    this.initNote();

    this.firstFormGroup.get("leadId").setValue(this.data['leadId']);


    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      this.selectedFile = file.file;
      this.buttonEnable = true;
      this.fileName = file.file.name;
      this.upload();  // <-- same upload for drag & select
    };


  }


  initNote() {
    this.firstFormGroup = this._formBuilder.group({
      noteId: [0],
      notes: [''],
      notesDocument: [''],
      leadId: [''],
      createdDate: [''],
      updatedDate: [''],
      createdBy: [''],
      updatedBy: [''],
      type: [''],
      taggedUser: [''],
      resource: [''],
      documentType: [''],
      template: []
    });
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  public hasBaseDropZoneOver = false;


  fileOverBase(event) {
    this.hasBaseDropZoneOver = event;
  }



  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['image', 'video', 'txt', 'doc', 'pdf', 'xls', 'xlsx', 'docx', 'audio'],
    maxFileSize: 16 * 1024 * 1024
  });


  editlead(lead: any) {

    this.firstFormGroup = this._formBuilder.group({
      noteId: lead.noteId,
      notes: lead.notes,
      notesDocument: lead.notesDocument,
      leadId: lead.leadId,
      createdDate: lead.createdDate,
      updatedDate: lead.updatedDate,
      createdBy: lead.createdBy,
      updatedBy: lead.updatedBy,
      type: lead.type,
      taggedUser: lead.taggedUser,
      resource: lead.resource,
      documentType: lead.documentType,
    })


  }


  submit() {
    if (!this.selectedFile || !this.firstFormGroup.get('notesDocument')?.value) {
      this.snackBar.open("Please select and upload a file", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    if (this.text == 'Add' && this.firstFormGroup.valid) {

      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }

      this.text = "Processing"
      this.crmNoteService.addOrEditNote(this.firstFormGroup.value, this.type).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Add";
            this.snackBar.open("File Upload SuccessFully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });


            this.submitType();


          }
          else {
            this.text = "Add";
            this.snackBar.open("File Upload Failed", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        () => { this.text = "Add" });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  submitType() {

    this.dialogRef.close({ event: 'add', })

  }

  close() {
    this.dialogRef.close({ event: 'close' })
  }


  onFileSelected() {
    const files = this.getFiles();
    if (files.length > 0) {
      this.selectedFile = files[0];
      this.fileName = files[0].name;
      this.upload();
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.fileName = '';
    this.setAsDisplayPicture = false;
    this.buttonEnable = false;
    this.uploader.clearQueue();

    this.uploadedMediaFileName = '';
    this.mimeType = '';
    this.uploadedMediaType = '';
    this.uploadedMediaUrl = '';
    this.data1 = null;

    if (this.firstFormGroup) {
      this.firstFormGroup.patchValue({
        notesDocument: '',
        documentType: '',
        resource: '',
      });
    }

    if (this.myInputVariable) {
      this.myInputVariable.nativeElement.value = "";
    }

  }



  upload(): void {
    const files = this.getFiles();
    const data = new FormData();

    if (files.length > 0) {
      this.uploadInProgress = true;

      files.forEach((file: any) => {
        data.append('files', file.rawFile, file.name.replace(/\s/g, "_")
          .replace(/\(/g, '_')
          .replace(/\)/g, '_'));
      });

      this.fileUploadService.normalUploadFiles(data, 'crmFiles', this.locations).subscribe({
        next: (res: any) => {
          this.data1 = res;
          if (res && res.status_code === '500') {
            this.snackBar.open(res.status_message || 'An error occurred during upload', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            this.uploadInProgress = false;
            this.buttonEnable = false;
            return;
          }

          this.uploadProgress = 100;
          this.uploader.clearQueue();

          if (this.myInputVariable) {
            this.myInputVariable.nativeElement.value = "";
          }

          const fileName = res?.productEntityMediaGallery?.[0]?.fileName ?? '';
          const mimeType = files[0].type;

          if (fileName) {
            this.handleUploadedFile(fileName, mimeType);

            // patch into formGroup
            this.firstFormGroup.patchValue({
              notesDocument: fileName,
              documentType: this.mapMimeToDocType(mimeType),
              resource: mimeType,
            });
          }
        },
        error: () => {
          this.snackBar.open('Upload failed', 'Close', { duration: 3000 });
          this.uploadInProgress = false;
          this.buttonEnable = false;
        }
      });
    } else {
      alert("No Items Found");
    }
  }


  mapMimeToDocType(mime: string, fileName: string = ''): string {
    mime = mime?.toLowerCase() || '';
    fileName = fileName?.toLowerCase() || '';

    if (mime.startsWith('video/')) return "1";

    if (mime.startsWith('audio/')) return "2";

    if (mime === 'application/pdf' || fileName.endsWith('.pdf')) return "3";

    if (mime.startsWith('image/')) return "4";

    if (
      mime === 'application/msword' ||
      mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      fileName.endsWith('.doc') ||
      fileName.endsWith('.docx')
    ) return "5";

    if (
      mime === 'application/vnd.ms-excel' ||
      mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx')
    ) return "6";

    if (
      mime === 'application/vnd.ms-powerpoint' ||
      mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      fileName.endsWith('.ppt') ||
      fileName.endsWith('.pptx')
    ) return "7";


    return "4";
  }


  handleUploadedFile(fileName: string, mime: string) {
    const cid = localStorage.getItem(Constant.enterPriseKey);
    const basePath = environment.commonImageApi + '/crmFiles/';
    fileName = fileName.split('/').pop() || '';
    this.uploadedMediaFileName = fileName;
    this.mimeType = mime;
    this.uploadedMediaUrl = basePath + fileName + "&cid=" + cid;

    if (mime.includes('image')) this.uploadedMediaType = 'image';
    else if (mime.includes('video')) this.uploadedMediaType = 'video';
    else if (mime.includes('audio')) this.uploadedMediaType = 'audio';
    else this.uploadedMediaType = 'document';

    this.uploadInProgress = false;
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
